import { PROCESSING_TASK } from "./const.js";
export const _checkIsPathEditing = (self) => {
  if (self._processing_task !== PROCESSING_TASK.PATH_EDITING) {
    throw new Error(
      `패스 편집중이 아닙니다. : ${self._processing_task?.toString() ?? "null"}`
    );
  }
};
